<template>
  <div class="add-address-container">
    <!--头部-->
    <titleHeader title="收货地址"></titleHeader>
    <van-address-edit
      :area-list="areaList"
      :address-info="addressInfo"
      show-postal
      show-set-default
      show-search-result
      show-delete
      :search-result="searchResult"
      @save="saveAddress"
      @delete="deleteAddress"
    />
    <!-- 从微信收货地址导入，只有新增时展示 -->
    <div class='openWxAddress' v-show='!addressInfo.id' @click='openWxAddress'>从微信收货地址导入</div>
  </div>
</template>

<script>
import arealist from 'common/js/area';
import api from 'api/user';
import { Toast } from 'vant';
import { getWxSign } from 'common/js/getSDKSign';
import wx from 'weixin-js-sdk';
export default {
  data() {
    return {
      display: {
        areaSelect: false,
      },
      addressInfo: {
      },
      errorMsg: '',
      areaList: arealist,
      searchResult: [],
    };
  },
  created() {
    if (this.$route.query.detail) {
      this.addressInfo = JSON.parse(this.$route.query.detail);
      this.addressInfo.isDefault = this.addressInfo.isDefault == 1;
    }
  },
  methods: {
    //保存收货地址
    async saveAddress(val) {
      let params = {
        ...val,
        isDefault:val.isDefault === true ? 1 : 0
      };
      if (this.addressInfo.id) {
        //编辑地址
        params.id = this.addressInfo.id;
        await api.updateAddress(params);
        Toast.success('更新成功');
        let query = {};
        if (this.$route.query.standard) {
          query.index = this.$route.query.index;
          query.standard = this.$route.query.standard
        }
        this.$router.push({
          path: '/address',
          query
        });
      } else {
        //新增地址
        await api.saveAddress(params);
        Toast.success('添加成功');
        let query = {
          index: 0
        };
        if (this.$route.query.standard) {
          query.standard = this.$route.query.standard
        }
        this.$router.push({
          path: 'address',
          query
        });
      }
    },
    //删除收货地址
    deleteAddress(val) {
      console.log(val);
      api.deleteAddress(val.id)
      .then(res=>{
        console.log(res);
        this.$router.go(-1)
      })
    },
    //从微信地址导入
    openWxAddress() {
      let _this = this;
      //获取签名并初始化jssdk
      getWxSign(function () {
        wx.openAddress({
          success: function (res) {
            console.log(res)
            _this.addressInfo = {
              name: res.userName,// 收货人姓名
              tel: res.telNumber,// 收货人手机号码
              areaCode: res.nationalCode,// 收货地址国家码
              postalCode: res.postalCode,// 邮编
              province: res.provinceName,// 国标收货地址第一级地址（省）
              city: res.cityName,// 国标收货地址第二级地址（市）
              county: res.countryName,// 国标收货地址第三级地址（国家）
              addressDetail: res.detailInfo// 详细收货地址信息
            }
            _this.$forceUpdate()
          }
        });
      })
    }
  },
};
</script>

<style scoped lang="scss">
@import 'common/sass/theme';
.add-address-container {
  .input-class {
    color: red;
  }
  .area-box {
    position: fixed;
    top: 0;
    width: 100vw;
    height: 100vh;
    .mask-layer {
      width: 100vw;
      height: 50vh;
      background: rgba(0, 0, 0, 0.6);
    }
    .area-content {
      height: 50vh;
    }
  }
  .openWxAddress{
    margin-left: 12px;
    font-size: 14px;
    text-decoration: underline;
    color: $theme-color;
  }
}
</style>
